module.exports = __webpack_public_path__ + "static/og-img-53dcd3545612f002521a3f0a4292d19f.jpg";